import {z} from "zod";

export const inviteHouseholdOccupantSchema = z.object({
  email: z
    .string()
    .trim()
    .min(1, "Email is required")
    .email("Enter a valid email address")
    .max(255, "Email is too long"),
  first_name: z.string().trim().min(1, "First name is required").max(100),
  last_name: z.string().trim().min(1, "Last name is required").max(100),
});

export type InviteHouseholdOccupantInput = z.infer<typeof inviteHouseholdOccupantSchema>;
